(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();
